export default __webpack_public_path__ + "static/media/Archivos_Envio.ac1a90fd.rar";